// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.lead.SatelliteWebRenterLeadHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebRenterLeadRequestToApplyRequestDto,
  SatelliteWebRenterLeadRequestToApplyResponseDto,
} from '../..';

export const SatelliteWebRenterLeadHandler_requestToApply_Path = '/api/web/renter/v1/lead/requestToApply';

/**
 * Request to apply to a listing
 */
export const SatelliteWebRenterLeadHandler_requestToApply = (
  postData: SatelliteWebRenterLeadRequestToApplyRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebRenterLeadRequestToApplyRequestDto,
    SatelliteWebRenterLeadRequestToApplyResponseDto
  >(
    {
      endpoint: SatelliteWebRenterLeadHandler_requestToApply_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
